import { useQuery } from "@tanstack/react-query";
import { lookupCustomer } from "../services/customerLookupService";

/** The last ten digits — what the customer record is keyed on, however it was typed. */
export const tenDigits = (phone) => {
  const digits = String(phone ?? "").replace(/\D/g, "");
  return digits.length >= 10 ? digits.slice(-10) : "";
};

const looksLikeEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v ?? "").trim());

/**
 * Whether the recipient is already a customer.
 *
 * Idle until there is something worth asking about — a half-typed address would
 * only produce a stream of misses. Cached briefly so switching between the form
 * and the send modal does not re-ask on every render.
 */
export const useCustomerLookup = ({ email, phone }) => {
  const validEmail = looksLikeEmail(email) ? String(email).trim() : "";
  const mobile = tenDigits(phone);

  return useQuery({
    queryKey: ["customer-lookup", validEmail, mobile],
    queryFn: () => lookupCustomer({ email: validEmail, mobile }),
    enabled: Boolean(validEmail || mobile),
    staleTime: 60 * 1000,
    retry: false,
  });
};
